import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import MatTable from '../../shared/components/material-table';
import {
  DEFAULT_PAGE_SIZE,
  COMMUNICATION_CHANNEL_TYPE,
} from '../../shared/utils/constants';
import Modal from '../../shared/components/Modal';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import {
  comChannelListByFilter,
  comChannelDeleteNoUnreadMessages,
  comChannelDeleteUnreadMessages,
} from '../../shared/queries/CommunicationChannel';
import GraphQl from '../../GraphQL';
import columns from './components/Columns';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import CommunicationChannelToReplaceModal from './components/CommunicationChannelToReplaceModal';

const CommunicationChannel = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState([]);
  const { t, history, dispatch } = props;
  const [deleteModal, setDeleteModal] = useState(false);

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const toggleModal = () => {
    setModal(!modal);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push('/minime/canal-comunicacao/mnt/0');
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    history.push(`/minime/canal-comunicacao/mnt/${rowData.id}`);
  };

  const listAllCommunicationChannels = () => {
    const filter = {
      id: 0,
      filterByActive: true,
      active: true,
      communicationChanelType: COMMUNICATION_CHANNEL_TYPE.EXTERNAL,
    };
    const query = comChannelListByFilter(filter);
    showLoading();
    GraphQl(query, {}).then((res) => {
      res.comChannelListByFilter = res.comChannelListByFilter.map((item) => ({
        ...item,
        label: item.name,
        value: item.id,
        isDisabled: false,
        availableToDescription: t(
          `mnt_communication_channel.availableTo-${item.availableTo}`
        ),
        typeDescription: t(
          `mnt_communication_channel.typeDescription.${item.type}`
        ),
      }));
      setData(res.comChannelListByFilter);
      hideLoading();
    });
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeMutation = comChannelDeleteNoUnreadMessages(selectedDto);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        listAllCommunicationChannels();
        hideLoading();
      });
  };

  const deleteUnReadMessagesItem = (
    selectedItem,
    communicationChanelToReplace
  ) => {
    const removeMutation = comChannelDeleteUnreadMessages(
      selectedItem,
      communicationChanelToReplace
    );
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
        listAllCommunicationChannels();
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-remove')
        );
      });
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });

    if (rowData.unreadMessageQuantity > 0) {
      toggleDeleteModal();
    } else {
      toggleModal();
    }
  };

  const updateChannelToReplace = (channel) => {
    toggleDeleteModal();
    if (channel) {
      deleteUnReadMessagesItem(selectedDto, channel);
    } else {
      showNotificationAutoDestroy(
        'warning',
        t('notifications.attention'),
        t('notifications.no-channel')
      );
    }
  };

  useEffect(() => {
    listAllCommunicationChannels();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="warning"
        message={t('notifications.delete_channel_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <CommunicationChannelToReplaceModal
        title={t('mnt_communication_channel.channel-to-replace-title')}
        modal={deleteModal}
        toggle={toggleDeleteModal}
        data={data}
        selectedDto={selectedDto}
        updateChannelToReplace={updateChannelToReplace}
      />

      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    columns={columns(t)}
                    pageSize={DEFAULT_PAGE_SIZE}
                    deleteAction={toggleModal}
                    onRefreshClick={listAllCommunicationChannels}
                    title={t('mnt_communication_channel.title')}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

CommunicationChannel.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(CommunicationChannel)
);
